import React from 'react';
import NewsCard from './NewsCard';

const Results = ({
    searchResultsJson,
    resultFallbackImageId,
    searchSummaryJson,
    onPaginationButtonClick,
    searchHasNoResults,
    BRANDMARK_SVG,
    isRequestingSearchResults,
}) => {
    const colorOptions = ['orange', 'pink', 'light-green', 'red', 'light-blue'];

    const getRandomColor = () => {
        const randomIndex = Math.floor(Math.random() * colorOptions.length);
        return colorOptions[randomIndex];
    };

    return (
        <div className="search-page-resources__results-container">
            {searchResultsJson.length !== 0 ? (
                <>
                    <ol className="search-page-resources__results-list">
                        {searchResultsJson.map((result) => {
                            const tilePalette = getRandomColor();
                            const resultImageId = resultFallbackImageId;

                            return (
                                <li
                                    className="search-page-resources__results-list-item"
                                    key={`result-${result?.rank}`}
                                >
                                    <NewsCard
                                        result={result}
                                        tilePalette={tilePalette}
                                        resultImageId={resultImageId}
                                    />
                                </li>
                            );
                        })}
                    </ol>

                    {searchSummaryJson.nextStart ? (
                        <button
                            className="search-page-resources__pagination-button"
                            onClick={onPaginationButtonClick}
                            type="button"
                        >
                            View more
                            <svg className="svg-icon">
                                <use
                                    xlinkHref="#rse-chevron-down-16"
                                    fill="none"
                                />
                            </svg>
                        </button>
                    ) : null}
                </>
            ) : null}

            {searchHasNoResults ? (
                <div className="search-page-resources__no-results-wrapper">
                    <div className="search-page-resources__no-results-title-container">
                        <div className="search-page-resources__no-results-brandmark-left">
                            {BRANDMARK_SVG()}
                        </div>
                        <h2 className="search-page-resources__no-results-title">
                            No results found
                        </h2>
                        <div className="search-page-resources__no-results-brandmark-right">
                            {BRANDMARK_SVG()}
                        </div>
                    </div>
                    <p className="search-page-resources__no-results-description">
                        Try searching for something more general, change the
                        filters or check for spelling mistakes.
                    </p>
                </div>
            ) : null}

            {isRequestingSearchResults ? (
                <div className="search-page-resources__result-loading-wrapper">
                    <div className="search-page-resources__result-loading-container">
                        <div className="search-page-resources__result-loading-animation" />
                        <p className="search-page-resources__result-loading-message">
                            Retrieving resources
                        </p>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Results;
